// import _ from 'lodash'
import { adminClient as apolloClient } from '@/store/apollo';

import CustomerGroupsGql from '@/extensions/shop/store/graphql/queries/CustomerGroups.gql';
// import CustomerGroupsPaginatedGql from '@/extensions/shop/store/graphql/queries/CustomerGroupsPaginated.gql';

export default {
    fetchList: (shopID = null) =>
        new Promise((resolve, reject) => {
            let variables = {};
            if (shopID) variables.shop = parseInt(shopID);

            apolloClient
                .query({
                    query: CustomerGroupsGql,
                    variables
                })
                .then(({ data }) => resolve(data.CO_CustomerGroups))
                .catch(err => reject(err));
        })
    // fetchCustomerGroupsPaginated: data =>
    //     new Promise((resolve, reject) => {
    //         let filters = [];
    //         _.each(data.filters, entry => filters.push(entry));
    //
    //         apolloClient
    //             .query({
    //                 query: CustomerGroupsPaginatedGql,
    //                 variables: {
    //                     currentPage: _.get(data, 'pageInfo.currentPage', 1),
    //                     perPage: _.get(data, 'pageInfo.perPage', 25),
    //                     order: _.get(data, 'variables.order', 'id'),
    //                     direction: _.get(data, 'variables.direction', 'asc'),
    //                     link: _.get(data, 'link.route', '/customer/group/'),
    //                     filters
    //                 }
    //             })
    //             .then(({ data }) => resolve(data.CO_CustomerGroupsPaginated))
    //             .catch(err => reject(err));
    //     })
    // fetchCustomerGroup: id => {
    //     if (id === undefined) throw new Error('required argument is missing')

    //     return new Promise((resolve, reject) => {
    //         apolloClient.query({
    //             query: CustomerGroupGql,
    //             variables: { id }
    //         })
    //             .then(({data}) => resolve(data.CO_CustomerGroup))
    //             .catch(err => reject(err))
    //     })
    // },
    // create: customerGroup => {
    //     if (customerGroup === undefined) throw new Error('required argument is missing')

    //     customerGroup = _.removeDeepByKey(customerGroup, '__typename')
    //     return new Promise((resolve, reject) => {
    //         apolloClient.mutate({
    //             mutation: CreateCustomerGroupGql,
    //             variables: { customerGroup }
    //         })
    //             .then(({data}) => {
    //                 apolloClient.clearStore()
    //                 resolve(data.CO_CreateCustomerGroup)
    //             })
    //             .catch(err => reject(err))
    //     })
    // },
    // update: customerGroup => {
    //     if (customerGroup === undefined) throw new Error('required argument is missing')

    //     customerGroup = _.removeDeepByKey(customerGroup, '__typename')
    //     return new Promise((resolve, reject) => {
    //         apolloClient.mutate({
    //             mutation: UpdateCustomerGroupGql,
    //             variables: { customerGroup }
    //         })
    //             .then(({data}) => {
    //                 apolloClient.clearStore()
    //                 resolve(data.CO_UpdateCustomerGroup)
    //             })
    //             .catch(err => reject(err))
    //     })
    // },
    // delete: id => {
    //     if (id === undefined) throw new Error('required argument is missing')

    //     return new Promise((resolve, reject) => {
    //         apolloClient.mutate({
    //             mutation: DeleteCustomerGroupGql,
    //             variables: { id }
    //         })
    //             .then(({data}) => {
    //                 apolloClient.clearStore()
    //                 resolve(data.CO_DeleteCustomerGroup)
    //             })
    //             .catch(err => reject(err))
    //     })
    // }
};
